export const dataForm = {
    subject: `[Romikya] mensaje de `,
    mail: 'c29jaWFsQHJvbWlreWEubXg=',
    formCode: 'xknakgpv'
}